import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { FilterContainer } from '../../../../containers/FilterContainer';
import BatteryBellNotification from '../../../../screens/Analytics/AnalyticsReports/Reports/Components/BatteryBellNotification';
import ReportTypeInput from '../../../../screens/Analytics/AnalyticsReports/ReportTypeInput';
import MapSelectInput from '../../../../screens/Analytics/AnalyticsReports/MapSelectInput';

// Analytics Report Tab Dropdown, Filters ETC
interface AnalyticsGridHeaderProps {
  reportType: string;
  filterControl: boolean;
  showBell: boolean;
  authorized: boolean;
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
  open: boolean;
  disableBtn?: boolean;
  onMapChange: (mapId: string, mapName: string) => void;
  onFilterChange: (val: any, type: string) => void;
  ChangeReportType: any;
  onSubmit: () => void;
  renderDateFilters: React.ReactNode;
}

export const AnalyticsGridHeader: React.FC<AnalyticsGridHeaderProps> = ({
  reportType,
  filterControl,
  showBell,
  authorized,
  anchorEl,
  setAnchorEl,
  open,
  disableBtn,
  onMapChange,
  onFilterChange,
  ChangeReportType,
  onSubmit,
  renderDateFilters,
}) => {
  const showFilter =
    filterControl && (reportType === 'battery' || reportType === 'trigger-resolution');

  const resolvedDisabledFilters =
    reportType === 'trigger-resolution'
      ? ['all', 'identifier', 'keyword', 'map', 'place', 'device id', 'battery value']
      : ['all'];

  return (
    <Card className="analytic-report-selector mb-3">
      <Card.Body>
        <div className="d-flex gap-3 analytic-report-selector-wrapper">
          <div className="header-input">
            <ReportTypeInput ChangeReportType={ChangeReportType} />
          </div>

          {reportType && reportType !== 'battery' && (
            <div className="date-filter">{renderDateFilters}</div>
          )}

          {reportType === 'gateway-network-uptime' && (
            <div className="map-select">
              <MapSelectInput onMapChange={onMapChange} />
            </div>
          )}

          {showFilter && (
            <div className="asset-filter">
              <FilterContainer
                onChange={onFilterChange}
                disabledFilters={resolvedDisabledFilters}
                filterReportType="asset-filter"
              />
            </div>
          )}

          {showBell && authorized && (
            <BatteryBellNotification anchorEl={anchorEl} setAnchorEl={setAnchorEl} open={open} />
          )}

          {reportType && (
            <div className="ms-auto submit-btn">
              <Button
                variant="primary"
                className={`px-5 float-right submit-report-btn ${
                  reportType === 'battery' ? 'submit-btn-battery' : ''
                }`}
                onClick={onSubmit}
                title="Submit Report"
                disabled={reportType !== 'battery' && disableBtn}
              >
                Submit
              </Button>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};
